import React, { useState, useEffect } from 'react';
import editeventStyle from './EditAddEventPage.module.css';
import CoordinatorHeader from '../../components/Header/CoordinatorHeader';
import CoordinatorPageBar from '../../components/CoordinatorPageBar/CoordinatorPageBar';
import CoordinatorMobilPageBar from '../../components/CoordinatorMobilPageBar/CoordinatorMobilPageBar'
import SideBar from '../../components/SideBar/SideBar';
import { useMediaQuery } from 'react-responsive';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from "axios";
import Swal from "sweetalert2";
import { FiEdit2 } from "react-icons/fi";

export default function EditAddEventPage() {

  const isMobile = useMediaQuery({ query: '(max-width: 768px)' });

  const location = useLocation();
  const [responseMessage, setResponseMessage] = useState('');
  const navigate = useNavigate();
  const [authorsData, setAuthorsData] = useState([]);  // Store authors data here
  const [editedStartTime, setEditedStartTime] = useState('');
  const [editedEndTime, setEditedEndTime] = useState('');

  // State for event details editing
  const [isEditingEvent, setIsEditingEvent] = useState(false);
  const [editedEventName, setEditedEventName] = useState('');
  const [editedEventDetail, setEditedEventDetail] = useState('');
  const [editedEventLocation, setEditedEventLocation] = useState('');
  const [editedEventNotes, setEditedEventNotes] = useState('');
  const [editedStartDate, setEditedStartDate] = useState('');
  const [editedEndDate, setEditedEndDate] = useState('');

  // State for author books editing
  const [isEditingAuthor, setIsEditingAuthor] = useState(false);
  const [editingAuthorIndex, setEditingAuthorIndex] = useState(null);
  const [editingBookIndex, setEditingBookIndex] = useState(null);
  const [editedBookTitle, setEditedBookTitle] = useState('');
  const [editedBookISBN, setEditedBookISBN] = useState('');
  const [editedBookPrice, setEditedBookPrice] = useState('');

  const [isSubmitting, setIsSubmitting] = useState(false);

  // Get the previous page from location state
  const previousPage = location.state?.from || '/coordinator-dashboard';

  // Function to handle back navigation
  const handleBack = () => {
    navigate('/coordinator-dashboard');
  };

  useEffect(() => {
    const storedStartTime = localStorage.getItem('eventStarttime') || '';
    const storedEndTime = localStorage.getItem('eventEndtime') || '';
    setEditedStartTime(storedStartTime);
    setEditedEndTime(storedEndTime);
  }, []);

  useEffect(() => {
    const storedData = localStorage.getItem('authorsBooksdata');

    if (storedData) {
      try {
        const bookDataArray = JSON.parse(storedData);

        if (Array.isArray(bookDataArray)) {
          setAuthorsData(bookDataArray);  // Update authorsData state
        } else {
          setAuthorsData([]);  // Fallback to empty array
        }
      } catch (error) {
        setAuthorsData([]);  // Fallback to empty array on error
      }
    } else {
      setAuthorsData([]);  // Fallback to empty array if no data is found
    }
  }, []); // Empty dependency array ensures this effect runs only once
  //localStorage.removeItem('eventDate');
  const cordinatorID = localStorage.getItem('cordinator_id');
  const cordinatorFName = localStorage.getItem('coordinatorFName');
  const cordinatorLName = localStorage.getItem('coordinatorLName');
  const cordinatorPosition = localStorage.getItem('coordinatorPosition');
  const cordinatorPic = localStorage.getItem('coordinatorPic');
  const authorName = localStorage.getItem('authorName');
  const authorEmail = localStorage.getItem('authorEmail');
  const authorID = localStorage.getItem('authorId');
  const cordinator_id = localStorage.getItem('cordinator_id');
  const eventName = localStorage.getItem('eventName');
  //const eventDate = JSON.parse(localStorage.getItem('eventDate'));

  const eventStartTime = localStorage.getItem('eventStarttime') || '';
  const eventEndTime = localStorage.getItem('eventEndtime') || '';
  //const endDate = new Date(eventDate[1]);

  const eventDetail = localStorage.getItem('eventDetail');
  const eventLocation = localStorage.getItem('eventLocation');
  const eventNotes = localStorage.getItem('eventNotes');

  // Initialize edited values when component mounts
  useEffect(() => {
    const storedEventName = localStorage.getItem('eventName');
    const storedEventDetail = localStorage.getItem('eventDetail');
    const storedEventLocation = localStorage.getItem('eventLocation');
    const storedEventNotes = localStorage.getItem('eventNotes');
    //const storedEventDate = JSON.parse(localStorage.getItem('eventDate'));
    const storedEventDate = JSON.parse(localStorage.getItem('eventDate')) || [null, null];


    if (storedEventName) setEditedEventName(storedEventName);
    if (storedEventDetail) setEditedEventDetail(storedEventDetail);
    if (storedEventLocation) setEditedEventLocation(storedEventLocation);
    if (storedEventNotes) setEditedEventNotes(storedEventNotes);
    if (storedEventDate && storedEventDate.length === 2) {
      setEditedStartDate(formatDateForInput(storedEventDate[0]));
      setEditedEndDate(formatDateForInput(storedEventDate[1]));
    }
  }, []);

  const handleEventEdit = () => {
    setIsEditingEvent(true);
  };

  const handleEventSave = () => {
    localStorage.setItem('eventDate', JSON.stringify([editedStartDate, editedEndDate]));
    localStorage.setItem('eventStarttime', editedStartTime);
    localStorage.setItem('eventEndtime', editedEndTime);

    setIsEditingEvent(false);
    Swal.fire({
      title: "Success!",
      text: "Event details updated successfully!",
      icon: "success",
      timer: 2000,
      showConfirmButton: false,
    });
  };

  const handleAuthorEdit = () => {
    setIsEditingAuthor(true);
  };

  const handleAuthorSave = () => {
    // Update authorsData in localStorage
    localStorage.setItem('authorsBooksdata', JSON.stringify(authorsData));

    setIsEditingAuthor(false);
    Swal.fire({
      title: "Success!",
      text: "Author details updated successfully!",
      icon: "success",
      timer: 2000,
      showConfirmButton: false,
    });
  };

  const handleBookEdit = (authorIndex, bookIndex) => {
    setEditingAuthorIndex(authorIndex);
    setEditingBookIndex(bookIndex);
    const book = authorsData[authorIndex].authorBookDataAdded[0].books[bookIndex];
    setEditedBookTitle(book.title);
    setEditedBookISBN(book.isbn);
    setEditedBookPrice(book.price);
  };

  const handleBookSave = (authorIndex, bookIndex) => {
    const updatedAuthorsData = [...authorsData];
    updatedAuthorsData[authorIndex].authorBookDataAdded[0].books[bookIndex] = {
      ...updatedAuthorsData[authorIndex].authorBookDataAdded[0].books[bookIndex],
      title: editedBookTitle,
      isbn: editedBookISBN,
      price: editedBookPrice
    };

    setAuthorsData(updatedAuthorsData);
    setEditingAuthorIndex(null);
    setEditingBookIndex(null);
  };

  // Format date for <input type="date">
  /*const formatDateForInput = (dateStr) => {
    if (!dateStr) return '';
    // Just return YYYY-MM-DD (already stored in localStorage)
    return dateStr.split('T')[0]; // handles ISO string too
  }; */

  const formatDateForInput = (dateStr) => {
    if (!dateStr) return '';

    // If already clean (YYYY-MM-DD)
    if (!dateStr.includes('T')) return dateStr;

    // FIX: Convert ISO to LOCAL DATE safely
    const d = new Date(dateStr);

    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');

    return `${yyyy}-${mm}-${dd}`;
  };

  const formatMMDDYYYY = (dateStr) => {
    if (!dateStr) return '';

    // ALWAYS treat as local string
    const [year, month, day] = dateStr.split('-');

    return `${month}/${day}/${year}`;
  };

  // Format date for display MM/DD/YYYY
  /*const formatMMDDYYYY = (dateStr) => {
    if (!dateStr) return '';

    // If ISO format exists, extract only YYYY-MM-DD part
    const cleanDate = dateStr.includes('T')
      ? dateStr.split('T')[0]
      : dateStr;

    const [year, month, day] = cleanDate.split('-');

    if (!year || !month || !day) return '';

    return `${month}/${day}/${year}`;
  }; */


  const saveData = async () => {

    if (isSubmitting) return;

    // Validation
    /*const hasValidAuthors = authorsData.every(author => 
      Array.isArray(author.authorBookData) && author.authorBookData.length > 0
    );*/

    const hasValidAuthors = authorsData.every(author =>
      Array.isArray(author.authorBookDataAdded) &&
      author.authorBookDataAdded.length > 0 &&
      author.authorBookDataAdded[0].books.length > 0
    );

    if (editedEventName.trim() === "Event Test" || editedEventNotes.trim() === "If you have any additional Notes." || !hasValidAuthors) {
      alert("Please Add the Mandatory Event Details .");
      return;
    }

    setIsSubmitting(true);
    // Prepare the data to send
    const postData = {
      bookDataArray: authorsData,
      cordinator_id,
      eventName: editedEventName,
      formattedStartDate: editedStartDate,
      formattedEndDate: editedEndDate,
      eventDetail: editedEventDetail,
      eventLocation: editedEventLocation,
      eventNotes: editedEventNotes,
      event_start_time: editedStartTime,
      event_end_time: editedEndTime,
      event_status: "submitted"  //  ADD THIS
    };

    try {
      // Send data to the PHP API
      const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/save_event_data.php`, postData, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      // Handle the response
      if (response.data.status === 'success') {
        Swal.fire({
          title: "Success!",
          text: "Event saved successfully! Redirecting to your profile...",
          icon: "success",
          timer: 3500,
          showConfirmButton: false,
        }).then(() => {
          navigate(`/coordinator-dashboard`);
        });
      } else {
        alert(response.data.message);
        setIsSubmitting(false);
      }
    } catch (error) {
      alert('Something went wrong! Please try again.');
      setIsSubmitting(false);
    }
  };

  const handleAddAuthor = () => {
    const newAuthor = {
      authorId: Date.now(), // temporary unique id
      authorName: "",
      authorEmail: "",
      authorBookDataAdded: [
        {
          author_name: "",
          books: []
        }
      ]
    };

    setAuthorsData([...authorsData, newAuthor]);
    setIsEditingAuthor(true);
  };

  const handleAddBook = (authorIndex) => {
    const updatedAuthors = [...authorsData];

    updatedAuthors[authorIndex].authorBookDataAdded[0].books.push({
      title: "",
      isbn: "",
      price: ""
    });

    setAuthorsData(updatedAuthors);
  };

  const handleDeleteAuthor = (authorIndex) => {
    const updatedAuthors = authorsData.filter((_, index) => index !== authorIndex);
    setAuthorsData(updatedAuthors);
  };

  const handleDeleteBook = (authorIndex, bookIndex) => {
    const updatedAuthors = [...authorsData];

    updatedAuthors[authorIndex]
      .authorBookDataAdded[0]
      .books.splice(bookIndex, 1);

    setAuthorsData(updatedAuthors);
  };

  // const handleBookwormApproval = (e) => {
  //   e.preventDefault();

  //   Swal.fire({
  //     title: "Not Allowed",
  //     text: "Only admin can delete this event.",
  //     icon: "info",
  //     timer: 2500,
  //     showConfirmButton: false,
  //   });
  // };

  //   const handleBookwormApproval =  async (e) => {
  //   e.preventDefault();

  //     await Swal.fire({
  //       title: "Information",
  //       text: "Only admin can delete this event.",
  //       icon: "info",
  //       timer: 2500,
  //       showConfirmButton: false,
  //        showConfirmButton: false,
  //     // timerProgressBar: true,
  //     // didOpen: () => {
  //     //   Swal.showLoading(); // optional loading animation
  //     // }
  //     });

  //   await saveData();
  // };

  const handleBookwormApproval = async (e) => {
    e.preventDefault();

    // Show confirmation popup
    const result = await Swal.fire({
      title: "Confirm Action",
      text: "User will not delete and edit this event",
      icon: "info",
      showCancelButton: true,
      confirmButtonText: "Agree",
      cancelButtonText: "Cancel",
      reverseButtons: true, // optional: swaps positions of buttons
    });

    // If user clicks "Agree"
    if (result.isConfirmed) {
      await saveData(); // call your saveData function
    }

    // If user clicks "Cancel", do nothing
  };

  return (
    <>
      <CoordinatorHeader />
      {isMobile ? (
        <div className={editeventStyle.editaddeventmobiltopbar}>
          <div className='container'>
            <div className='row'>
              <div className='col-lg-12'>
                <CoordinatorMobilPageBar />
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className={editeventStyle.editaddeventdesktoptopbar}>
          <div className='container'>
            <div className='row'>
              <div className='col-lg-12'>
                <CoordinatorPageBar />
              </div>
            </div>
          </div>
        </div>
      )}

      {isMobile ? (
        <div className={editeventStyle.editaddeventmobilpage}>
          <div className='container'>
            <div className='row'>
              <div className='col'>
                <div className={editeventStyle.editevntmobilText}>
                  <h4>Your'e Almost There!</h4>
                  <p> Before you submit your author event request to Bookworm Central, take a quick moment
                    to review the details to make sure everything's set. Once you're happy with everything,
                    go ahead and submit! This will help ensure a smooth event planning process.
                  </p>
                </div>
                <div className={editeventStyle.mobileditaddEventbox}>
                  <div className='row'>
                    <div className='col-12'>
                      <h5>Event Name</h5>
                      <p>Behind the Pages: Elliot Finch</p>
                      <h5>Start and End Date</h5>
                      <p>00/00/0000 - 00/00/0000</p>
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col-6'>
                      <h5>Event Details</h5>
                      <p>Grade K-6</p>
                    </div>
                    <div className='col-6'>
                      <h5>Location</h5>
                      <p>Library</p>
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col-12'>
                      <h4>Notes</h4>
                      <p> Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                        incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud
                        exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
                      </p>
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col-12'>
                      <hr className='mt-2' />
                    </div>
                  </div>
                  <div className={editeventStyle.mobileditaddEventtabl}>
                    <div className='row'>
                      <div className='col-12'>
                        <h4>Authors</h4>
                      </div>
                      <div className='col-5'>
                        <h6>Elliot Finch</h6>
                        <p>The Enchanted</p>
                        <p>Mystic Mountain</p>
                        <p>Secrets of the Sea</p>
                      </div>
                      <div className='col-4 text-center'>
                        <h6>ISBN</h6>
                        <p>0987654321123</p>
                        <p>0987654321123</p>
                        <p>0987654321123</p>
                      </div>
                      <div className='col-3 text-center'>
                        <h6>Price</h6>
                        <p>$00.00</p>
                        <p>$00.00</p>
                        <p>$00.00</p>
                      </div>
                    </div>
                    <div className='row'>
                      <div className='col-12'>
                        <hr className='mt-2' />
                      </div>
                    </div>
                    <div className='row'>
                      <div className='col-5'>
                        <h6>Elliot Finch</h6>
                        <p>The Enchanted</p>
                        <p>Mystic Mountain</p>
                        <p>Secrets of the Sea</p>
                      </div>
                      <div className='col-4 text-center'>
                        <h6>ISBN</h6>
                        <p>0987654321123</p>
                        <p>0987654321123</p>
                        <p>0987654321123</p>
                      </div>
                      <div className='col-3 text-center'>
                        <h6>Price</h6>
                        <p>$00.00</p>
                        <p>$00.00</p>
                        <p>$00.00</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='row g-2 mb-4'>
              <div className='col-6'>
                <button className={`${editeventStyle.editeventsaveButnmobil} btn btn-secondary w-100`}>Save</button>
              </div>
              <div className='col-6'>
                <button className={`${editeventStyle.editeventsubmitButnmobil} btn btn-success w-100`}>Submit</button>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className={editeventStyle.editaddeventdesktoppage}>
          <div className='container'>
            <div className='row'>
              <div className='col' style={{ maxWidth: '275px' }}>
                <SideBar degination={cordinatorPosition} uname={cordinatorFName} ulname={cordinatorLName} userid={cordinatorID} />
              </div>
              <div className="col">
                <div className={editeventStyle.editeventPage}>
                  <div className={editeventStyle.almostcontentBox}>
                    <h3> You're Almost There! </h3>
                    <p>  Before you submit your author event request to Bookworm Central, take a quick moment to review the details to
                      make sure everything's set. Once you're happy with everything, go ahead and submit! This will help ensure a
                      smooth event planning process.
                    </p>
                  </div>
                  <div className="row mb-4">
                    <div className="col-xl-4 col-xxl-4">
                      <div className={editeventStyle.eventData}>
                        <div className="d-flex justify-content-between align-items-center">
                          <h5>Event Name</h5>
                        </div>
                        {isEditingEvent ? (
                          <input
                            type="text"
                            className="form-control mb-2"
                            value={editedEventName}
                            onChange={(e) => setEditedEventName(e.target.value)}
                          />
                        ) : (
                          // <p>{eventName}</p>
                          <p>{editedEventName}</p>
                        )}
                        <h5>Event Details</h5>
                        {isEditingEvent ? (
                          <input
                            type="text"
                            className="form-control mb-2"
                            value={editedEventDetail}
                            onChange={(e) => setEditedEventDetail(e.target.value)}
                          />
                        ) : (
                          // <p>{eventDetail}</p>
                          <p>{editedEventDetail}</p>
                        )}


                        <h5>Location</h5>
                        {isEditingEvent ? (
                          <input
                            type="text"
                            className="form-control mb-2"
                            value={editedEventLocation}
                            onChange={(e) => setEditedEventLocation(e.target.value)}
                          />
                        ) : (
                          // <p>{eventLocation}</p>
                          <p>{editedEventLocation}</p>
                        )}
                      </div>
                    </div>
                    <div className="col-xl-4 col-xxl-4">
                      <div className={editeventStyle.eventData}>
                        <h5>Start and End Date</h5>
                        {isEditingEvent ? (
                          <div className="d-flex gap-2 mb-2">
                            <input
                              type="date"
                              className="form-control"
                              value={editedStartDate}
                              onChange={(e) => setEditedStartDate(e.target.value)}
                            />
                            <input
                              type="date"
                              className="form-control"
                              value={editedEndDate}
                              onChange={(e) => setEditedEndDate(e.target.value)}
                            />
                          </div>
                        ) : (
                          <p>{formatMMDDYYYY(editedStartDate)} - {formatMMDDYYYY(editedEndDate)}</p>

                        )}
                        <h5>Start and End Time</h5>
                        {isEditingEvent ? (
                          <div className="d-flex gap-2 mb-2">
                            <input
                              type="time"
                              className="form-control"
                              value={editedStartTime}
                              onChange={(e) => setEditedStartTime(e.target.value)}
                            />
                            <input
                              type="time"
                              className="form-control"
                              value={editedEndTime}
                              onChange={(e) => setEditedEndTime(e.target.value)}
                            />
                          </div>
                        ) : (
                          <p>{editedStartTime} - {editedEndTime}</p>
                        )}
                      </div>
                    </div>
                    <div className='col-xl-4 col-xxl-4 text-end'>
                      <button type='button' className={`${editeventStyle.editbutton} btn btn-light`} onClick={handleEventEdit}>
                        Edit <FiEdit2 className={`${editeventStyle.editIconpencel} ms-1`} />
                      </button>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-xl-10 col-xxl-10">
                      <div className={editeventStyle.notesContent}>
                        <h4>Notes</h4>
                        {isEditingEvent ? (
                          <textarea
                            className="form-control mb-2"
                            rows="4"
                            value={editedEventNotes}
                            onChange={(e) => setEditedEventNotes(e.target.value)}
                          />
                        ) : (
                          // <p>{eventNotes}</p>
                          <p>{editedEventNotes}</p>

                        )}
                      </div>
                    </div>
                  </div>
                  {isEditingEvent && (
                    <div className="row mb-4">
                      <div className="col-12">
                        <button className="btn btn-success" onClick={handleEventSave}>Save Changes</button>
                        <button className="btn btn-secondary ms-2" onClick={() => setIsEditingEvent(false)}>Cancel</button>
                      </div>
                    </div>
                  )}
                  <hr style={{ borderColor: '#707070' }} />
                  <div className="row">
                    <div className="col-lg-12">
                      <div className={editeventStyle.authorDetail}>
                        <div className={editeventStyle.parttwodatatitle}>
                          <div className="d-flex justify-content-between align-items-center w-100">
                            <h5>Author Name</h5>
                            {/* <button className="btn btn-primary btn-sm ms-2" onClick={handleAddAuthor}>
                            + Add Author
                          </button> */}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className='col-lg-3 text-end d-none'>
                      <button type='button' className={`${editeventStyle.editbutton} btn btn-light`} onClick={handleAuthorEdit}>
                        Edit <FiEdit2 className={`${editeventStyle.editIconpencel} ms-1`} />
                      </button>
                    </div>
                  </div>

                  {/* Author Data */}
                  {authorsData.map((author, authorIndex) => (
                    <div key={author.authorId}>
                      <div className={editeventStyle.authortopData}>
                        <div className='me-auto'>
                          <h5 className="pe-5"><strong>Name:</strong> {author.authorName}</h5>
                          <p><strong>Email Id: </strong>{author.authorEmail || 'No email available'}</p>
                        </div>
                        {/* <div>
                        <button className="btn btn-outline-success btn-sm" onClick={() => handleAddBook(authorIndex)}>
                          + Add Book
                        </button>                      
                        <button className="btn btn-danger btn-sm ms-2" onClick={() => handleDeleteAuthor(authorIndex)}>
                          Delete Author
                        </button> 
                      </div>      */}
                      </div>
                      <div className="row mb-2">
                        <div className="col-lg-12">
                          <div className="table-responsive">
                            <table className={`${editeventStyle.authorTable} table table-bordered`}>
                              <thead>
                                <tr>
                                  <th>Author</th>
                                  <th>Title</th>
                                  <th>ISBN</th>
                                  <th>Price</th>
                                  {isEditingAuthor && <th className="text-center" width='150'>Actions</th>}
                                </tr>
                              </thead>
                              {author.authorBookDataAdded && Array.isArray(author.authorBookDataAdded) && author.authorBookDataAdded.length > 0 ? (
                                <tbody>
                                  {author.authorBookDataAdded.map((data, index) => (
                                    data.books.map((book, bookIndex) => (
                                      <tr key={`${authorIndex}-${bookIndex}`}>
                                        <td>{data.author_name}</td>
                                        <td>
                                          {isEditingAuthor && editingAuthorIndex === authorIndex && editingBookIndex === bookIndex ? (
                                            <input
                                              type="text"
                                              className="form-control"
                                              value={editedBookTitle}
                                              onChange={(e) => setEditedBookTitle(e.target.value)}
                                            />
                                          ) : (
                                            book.title
                                          )}
                                        </td>
                                        <td>
                                          {isEditingAuthor && editingAuthorIndex === authorIndex && editingBookIndex === bookIndex ? (
                                            <input
                                              type="text"
                                              className="form-control"
                                              value={editedBookISBN}
                                              onChange={(e) => setEditedBookISBN(e.target.value)}
                                            />
                                          ) : (
                                            book.isbn
                                          )}
                                        </td>
                                        <td>
                                          {isEditingAuthor && editingAuthorIndex === authorIndex && editingBookIndex === bookIndex ? (
                                            <input
                                              type="text"
                                              className="form-control"
                                              value={editedBookPrice}
                                              onChange={(e) => setEditedBookPrice(e.target.value)}
                                            />
                                          ) : (
                                            <p>{`$${book.price}`}</p>
                                          )}
                                        </td>
                                        {isEditingAuthor && (
                                          <td className="text-center">
                                            {editingAuthorIndex === authorIndex && editingBookIndex === bookIndex ? (
                                              <div>
                                                <button
                                                  className="btn btn-success btn-sm me-1"
                                                  onClick={() => handleBookSave(authorIndex, bookIndex)}
                                                >
                                                  {/* Save */}
                                                  <i class="fa fa-save"></i>
                                                </button>
                                                <button
                                                  className="btn btn-secondary btn-sm me-1"
                                                  onClick={() => {
                                                    setEditingAuthorIndex(null);
                                                    setEditingBookIndex(null);
                                                  }}
                                                >
                                                  {/* Cancel */}
                                                  <i class="fa fa-times"></i>
                                                </button>
                                                <button
                                                  className="btn btn-danger btn-sm"
                                                  onClick={() => handleDeleteBook(authorIndex, bookIndex)}
                                                >
                                                  {/* Delete */}
                                                  <i class="fa fa-trash"></i>
                                                </button>
                                              </div>
                                            ) : (
                                              <div>
                                                <button
                                                  className="btn btn-link p-0 me-2"
                                                  onClick={() => handleBookEdit(authorIndex, bookIndex)}
                                                >
                                                  <FiEdit2 />
                                                </button>
                                                <button
                                                  className="btn btn-danger btn-sm"
                                                  onClick={() => handleDeleteBook(authorIndex, bookIndex)}
                                                >
                                                  Delete
                                                </button>
                                              </div>
                                            )}
                                          </td>
                                        )}
                                      </tr>
                                    ))
                                  ))}
                                </tbody>
                              ) : (
                                <tbody>
                                  <tr>
                                    <td colSpan={isEditingAuthor ? "5" : "4"} className="text-center">No data available</td>
                                  </tr>
                                </tbody>
                              )}
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}

                  {isEditingAuthor && (
                    <div className="row mb-4">
                      <div className="col-12">
                        <button className="btn btn-success" onClick={handleAuthorSave}>Save All Changes</button>
                        <button className="btn btn-secondary ms-2" onClick={() => setIsEditingAuthor(false)}>Cancel</button>
                      </div>
                    </div>
                  )}

                  <div className="row mb-2">
                    <div className="col-lg-9">
                      <div className={editeventStyle.parttwoButton}>
                        <button className={`${editeventStyle.twosubmitbtn} btn btn-success`} onClick={handleBookwormApproval} disabled={isSubmitting}>
                          {isSubmitting ? 'Submitting...' : 'Submit to Bookworm for Approval'}
                        </button>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
